<template>
  <div class="hello">

    <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h3>Rivkah en Victor</h3>
          <p>Mijn zus Rivkah begon in 2014 met wedstrijden op de weg en daarna in het veld. Ik ben in 2015 in het veld begonnen. </p>
          <p>Met onze vader hebben wij in die tijd heel veel ervaring op gedaan.
            Daarbij hebben we ook heel veel geleerd over technische dingen die bij de jeugd nogal eens mis kunnen gaan.</p>
          <p>Via deze site bieden wij producten aan waarvan we uit ervaring weten dat die juist voor jeugdrenners handig zijn.</p>
        </div>
        <div class="col-sm-4">
          <h3>Techniek</h3>
          <p>De jeugd sport vaak in de breedte en daarom hebben wij onderdelen en accessoires voor wielrennen, veldrijden, mountainbiken en baanwielrennen.</p>
          <p>We helpen ook met het afstellen van fietsen, want juist bij jeugd is iedereen verschillend en kan zelfs een kleine aanpassing al
          een wereld van verschil opleveren.</p>
          <p>We helpen ook bij het bepalen van de juiste verzetten in combinatie met de gebruikte banden en wij hebben zelf heel goede ervaringen met het
          rijden met een enkel blad voor.</p>
          <p>Kinderen hebben vaak moeite met schakelen en onze ervaring is dat ook daarin allerlei oplossingen bestaan, variërend van kiezen voor de juiste shifter
          het toepassen van een elektronisch schakelsysteem.</p>
        </div>
        <div class="col-sm-4">
          <h3>Assortiment</h3>
          <div class="list-group">
              <span v-for="a in assortiment" v-bind:key="a.id" class="list-group-item">
                {{a.naam}}
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      assortiment: [
        {id: 1, naam: 'Cassettes en kettingbladen'},
        {id: 2, naam: 'Crankstellen en pedalen'},
        {id: 3, naam: 'Kettingbladen'},
        {id: 4, naam: 'Groepsets en onderdelen'},
        {id: 5, naam: 'Remmen'},
        {id: 6, naam: 'Wielen'},
        {id: 7, naam: 'Sturen, stuurpennen, zadelpennen'},
        {id: 8, naam: 'Banden'}
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?c83f4f04